import React, { Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { useDownloadCSVData } from 'src/pages/SharedPageCustomHooks/UseDownloadCSV/useDownloadCSVData';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import Button from 'src/components/Button';
import { useDownloadPDF } from 'src/pages/SharedPageCustomHooks/UseDownloadPDF/useDownloadPDF';

interface DownloadCSVParserOverlayProps {
  showDownloadOverlay: boolean;
  setShowDownloadOverlay: Dispatch<SetStateAction<boolean>>;
  serviceRequestIds: string[];
}

export const DownloadCSVAndPDFParserOverlay = ({
  showDownloadOverlay,
  setShowDownloadOverlay,
  serviceRequestIds,
}: DownloadCSVParserOverlayProps) => {
  const user: any = useSelector(selectAuthenticatedUser);

  const { isLoading, onDownloadCSV, clearData } = useDownloadCSVData();

  const {
    isLoading: isLoadingPDF,
    onDownloadPDF,
    clearError: clearPDFError,
  } = useDownloadPDF();

  const downloadCSV = async () => {
    setShowDownloadOverlay(false);
    await onDownloadCSV(serviceRequestIds);
  };

  const downloadPDF = async () => {
    setShowDownloadOverlay(false);
    await onDownloadPDF(user.id, serviceRequestIds.join('&'));
  };

  const handleClose = () => {
    setShowDownloadOverlay(false);
    clearData();
  };

  return (
    <GenericDialogue
      isOpen={showDownloadOverlay}
      onClose={() => handleClose()}
      title="Download CSV Overlay"
      description="Refine your contact list with the options below"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          gap: '1rem',
        }}
      >
        <Button
          color="teal"
          label={isLoading ? 'Preparing CSV...' : 'CSV download'}
          size="tiny"
          onClick={downloadCSV}
          disabled={isLoading}
        />
        <Button
          color="teal"
          label="PDF download"
          size="tiny"
          onClick={downloadPDF}
          disabled={isLoading}
        />
      </div>
    </GenericDialogue>
  );
};
